import { makeStyles } from '@material-ui/core';
import techneLogo from './assets/techne-logo.png';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    height: 32,
  },
  logo: {
    width: 32,
    height: 32,
    borderRadius: 6,
    display: 'block',
  },
  wordmark: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: 0.2,
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img className={classes.logo} src={techneLogo} alt="Techne" />
      <span className={classes.wordmark}>Techne</span>
    </div>
  );
};
